import React from 'react';
import { Link } from 'react-router-dom'; //  <-- 1. IMPORT Link for navigation
import { useState, useEffect } from 'react';
import axios from 'axios';

const PricingSection = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        // Use the environment variable for the API base URL
        const apiUrl = `${process.env.REACT_APP_API_BASE}/api/packages`;
        const response = await axios.get(apiUrl);
        
        const sortedPackages = response.data.sort((a, b) => a.price - b.price);
        setPackages(sortedPackages);

      } catch (err) {
        console.error('Error fetching packages:', err);
        setError('Failed to load pricing plans. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchPackages();
  }, []);

  const getPlanIcon = (price) => {
    switch (price) {
      case 99:
        return '/photos/sd1.png';
      case 149:
        return '/photos/sd2.png';
      case 299:
      case 249:
        return '/photos/sd3.png';
      default:
        return '/photos/sd1.png';
    }
  };
  
  const getButtonText = (price) => {
    switch (price) {
      case 99:
        return 'Get Basic Report';
      case 149:
        return 'Get Standard Report';
      case 299:
      case 249:
        return 'Get Premium Report';
      default:
        return 'Get Report';
    }
  };

  if (loading) {
    return <div className="pricing-section-container">Loading Plans...</div>;
  }

  if (error) {
    return <div className="pricing-section-container">{error}</div>;
  }

  return (
    <section className="price-main">
      <div className="pricing-section-container">
        <div className="section-heeader">
            {/* ... header content ... */}
            <div className="service-badge">Transparent Pricing for Every Need</div>
            <h1 className="main-pricing-title">
              Choose Your Perfect Plan
              <br />
              <span className="plan"></span>
            </h1>
            <p className="pricing-subtitle">
              AI‑powered immigration insights tailored to your goals and budget.
            </p>
        </div>
        
        <div className="pricing-plans-grid">
          {packages.map((pkg) => (
            <div
              key={pkg._id}
              className={`pricing-plan-card ${pkg.isPopular ? 'standard-plan-card' : ''}`}
            >
              {pkg.isPopular && (
                <div className="recommended-badge">Most Popular</div>
              )}
              
              <div className={`plan-icon-container`}>
                <img src={getPlanIcon(pkg.price)} alt={`${pkg.name} icon`} loading="lazy" />
              </div>

              <h3 className="plan-name-title">{pkg.name}</h3>
              <p>{pkg.description}</p>
              
              <div className="plan-price-display">
                <span className="currency-symbol">{pkg.currency === 'INR' ? '₹' : '$'}</span>
                <span className="price-amount">{pkg.price}</span>
                {pkg.originalPrice && (
                  <span className="original-price">₹{pkg.originalPrice}</span>
                )}
              </div>
              
              <ul className="plan-features-list">
                {pkg.features && pkg.features.map((feature, index) => (
                  <li key={index} className="feature-list-item">
                    <span className="feature-check-icon" />
                    {feature}
                  </li>
                ))}
              </ul>
              
              {/* --- 2. REPLACE a <button> with a <Link> component --- */}
              <Link
                // Construct the destination URL with the package ID as a query parameter
                to={`/dashboard?view=get-ai-report&packageId=${pkg._id}`}
                
                // Apply the same CSS classes to make the link look like a button
                className={`plan-action-button ${
                  pkg.isPopular ? 'primary-plan-button' : 'secondary-plan-button'
                } trigger-login-popup`}
              >
                {getButtonText(pkg.price)} →
              </Link>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;